import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setMileage } from '../../store/inventory/InitialFilterActions';
import { useFilteredInventoryData } from '../UseFilteredInventoryData';

export const useSetMileage = () => {
  const { unfilteredData } = useFilteredInventoryData();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setMileage(getUniqueMileageFromInventoryData(unfilteredData)));
  }, [unfilteredData]);

  const getUniqueMileageFromInventoryData = (inventoryData) =>
    inventoryData
      .map((inventoryItem) => inventoryItem.miles)
      .reduce((arrayOfMileage, currentMileage) => {
        const exists = arrayOfMileage.find((mileage) => mileage === currentMileage);
        if (!exists && currentMileage) {
          arrayOfMileage.push(currentMileage);
        }
        return arrayOfMileage;
      }, [])
      .reduce(
        (acc, mileage) => {
          if (mileage < acc.min) {
            acc.min = Math.floor(mileage / 1000) * 1000;
          }
          if (mileage > acc.max) {
            acc.max = Math.ceil(mileage / 1000) * 1000;
          }
          return acc;
        },
        { min: 0, max: 0 },
      );
};
